import React from 'react';

export default () => <div>Settings</div>;
